import axios from 'axios';
import { toast } from 'react-toastify';

const baseUrl = window.API_URL
  ? window.API_URL + (window.API_URL.endsWith('/') ? '' : '/')
  : 'api_url_not_defined/';

class Http {

  static getLocalResource(path, params, errorHandler) {
    return this._method(path, 'GET', null, params, errorHandler);
  }

  static get(path, params, errorHandler) {
    return this._method(baseUrl + path, 'GET', null, params, errorHandler);
  }

  static getData(path, params, errorHandler) {
    return this._methodResponse(baseUrl + path, 'GET', null, params, errorHandler);
  }

  static delete(path, params, errorHandler) {
    return this._method(baseUrl + path, 'DELETE', null, params, errorHandler);
  }

  static post(path, data, params, errorHandler) {
    return this._method(baseUrl + path, 'POST', data, params, errorHandler);
  }

  static put(path, data, params, errorHandler) {
    return this._method(baseUrl + path, 'PUT', data, params, errorHandler);
  }

  static _method(path, method, data, params, errorHandler) {
    return axios({
      url: path,
      method,
      params,
      data
    }).then(response => response.data)
      .catch(error => this._errorCall(error, errorHandler));
  }

  static _methodResponse(path, method, data, params, errorHandler) {
    return axios({
      url: path,
      method,
      params,
      data
    }).then(response => response)
      .catch(error => this._errorCall(error, errorHandler));
  }

  static _errorCall(error, errorHandler) {
    let handled = errorHandler && errorHandler(error);

    if (!handled) {
      handled = error.toString();
    }
    if (typeof handled === 'string') {
      toast.error(handled);
    }

    throw error;
  }

  static addRequestInterceptor(fn) {
    axios.interceptors.request.use(fn);
  }
}

export default Http;
